<template>
  <button
    class="definition-operator operator-icon"
    :class="[levelClass, {'cant-drop-here': !canDropHere, 'not-editable': thisPartIsInACountGroup}]"
    :key="operator.definitionId"
    @dblclick="editOperator($event)"
    :disabled="disableDefinitionPart"
    :draggable="false"
    @dragover="dragOverHandler"
    @dragleave="dragLeaveHandler"
    @drop="dropHandler"
  >
    <svg-icon :class="operatorConfig.icon.class"
              :icon="operatorConfig.icon.svg"
              :width="operatorConfig.icon.width" :height="operatorConfig.icon.height"></svg-icon>
  </button>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon'
  import operators from '@/appComponents/workbench/targetDefinition/models/operators'
  import DragAndDropHandlers from '@/appComponents/oldWorkbench/targetDefinition/mixins/DragAndDropHandlers'
  import { UPDATE_OPERATOR } from '@/appComponents/oldWorkbench/targetDefinition/store/actions'
  import {PopoverFactory} from '@/components/common/popover'
  import { definitionPartTypes } from '@/appComponents/oldWorkbench/targetDefinition/store/mutations'

  export default {
    mixins: [
      DragAndDropHandlers
    ],
    components: {
      SvgIcon
    },
    props: {
      definitionId: {
        type: String
      },
      operator: {
        type: Object,
        required: true
      },
      level: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        defType: definitionPartTypes.OPERATOR
      }
    },
    computed: {
      levelClass () {
        return `level-${this.level}`
      },
      operatorConfig () {
        return operators[this.operator.value]
      },
      disableDefinitionPart () {
        return this.$store.getters.hasOwnProperty('disableDefinitionPart') ? this.$store.getters.disableDefinitionPart(this.definitionId) : false
      },
      thisPartIsInACountGroup () {
        return this.$store.getters.hasOwnProperty('isInACountGroup') ? this.$store.getters.isInACountGroup(this.definitionId) : false
      }
    },
    methods: {
      updateOperator (updatedOperator) {
        this.$store.dispatch(UPDATE_OPERATOR, {operator: this.operator, update: updatedOperator})
      },
      editOperator (e) {
        if (this.thisPartIsInACountGroup) return
        this.popover = PopoverFactory.createOperator({
          direction: 'top',
          operatorSelector: true,
          parent: e.currentTarget,
          miliseconds: 200
        })
        this.popover.$on('select', operator => {
          this.updateOperator(operator)
        })
      }
    }
  }
</script>

<style lang="scss">
  .definition-operator {
    $bg-color: color(blue-black, dark);

    position: relative;
    z-index: $z-1;
    flex-shrink: 0;
    flex-grow: 0;
    height: rem(40);
    width: rem(40);
    padding: 0;
    text-align: center;
    border-radius: 50%;
    border: rem(5) solid $bg-color;

    &.not-editable {
      cursor: not-allowed;
    }

    &.level-1 {
      background-color: color(target, level-1);

      &:hover {
        background-color: color(target, level-1-light);
      }
    }

    &.level-2 {
      background-color: color(target, level-2);

      &:hover {
        background-color: color(target, level-2-light);
      }
    }

    svg {
      margin: auto;
      fill: $bg-color;
    }

    &:focus {
      outline: none;
    }

    &:disabled:hover {
      border-color: $bg-color;
    }
  }
</style>



// WEBPACK FOOTER //
// DefinitionOperator.vue?46accff9